import { Injectable } from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {EntityContainerModel} from '../../../../../../models/aggregates/erp/entity';
import {Core2Config} from '../../shared/core2Config';
import {HttpClient} from '@angular/common/http';


@Injectable({
    providedIn: 'root'
  })
  export class MerchantEntityLoginService extends BaseApiTemplateService<EntityContainerModel> {
  
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/merchants/login-entity-ep';
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/merchants/login-entity-ep';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/merchants/login-entity-ep';
      this.httpClient = http;
    }
}